import React from 'react';
import SocialContainer from './social/SocialContainer';
import { useLocalization } from '../../../hooks/useLocalization';

interface SocialMediaContentProps {
    currentUser?: any;
    theme?: string;
}

const SocialMediaContent: React.FC<SocialMediaContentProps> = ({ currentUser, theme }) => {
    const { language } = useLocalization();
    const validTheme = theme === 'dark' ? 'dark' : 'light';

    // Default user mock
    const user = currentUser || {
        id: 'admin_1',
        name: 'Admin User',
        role: 'admin',
        email: 'admin@tourvisio.com'
    };

    return (
        <div className="w-full h-full">
            <SocialContainer
                currentUser={user}
                theme={validTheme}
                language={language as any}
            />
        </div>
    );
};

export default SocialMediaContent;
